export const formatEmailsList = (emails = []) => emails.map((email) => email.toLowerCase());
